// utils/debug.ts

type LogLevel = 'log' | 'info' | 'warn' | 'error';

/**
 * Creates a debug logger that logs messages only in development mode.
 *
 * @param {string} namespace - The namespace to categorize logs (e.g., "App", "API").
 * @returns {Function} A logger function.
 */
export function createDebugLogger(namespace: string) {
	const isDevelopment = process.env.NODE_ENV === 'development';

	return (message: string, level: LogLevel = 'log', ...optionalParams: any[]) => {
		if (isDevelopment) {
			if (level === 'info') {
				// Add lighter blue color and ℹ️ icon manually for "info"
				console.log(
					`%cℹ️ [${namespace}] ${message}`,
					'color: #87CEEB; font-weight: bold;', // Updated to an even lighter blue
					...optionalParams,
				);
			} else {
				console[level](`[${namespace}] ${message}`, ...optionalParams);
			}
		}
	};
}
